export default __webpack_public_path__ + "assets/bg-433e1bc6991063b050378ad2b2601cbe.jpg";